import React from "react";
import "./ManufacturingTopSection.css";
import Button from "../Button/Button";

const ManufacturingTopSection = ({
  title,
  buttonText = "Learn More",
  backgroundImage,
  description,
  children,
  scrollTargetId,
  videoUrl,
}) => {
  const handleClick = () => {
    if (scrollTargetId) {
      const section = document.getElementById(scrollTargetId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };
  return (
    <div
      className="hero-section"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="hero-overlay-content">
        {title && <h1 className="hero-title">{title}</h1>}
        {description && <p className="hero-description">{description}</p>}
        <Button
          text={buttonText}
          size="discord"
          onClick={handleClick}
        />
        {children}
      </div>
    </div>
  );
};

export default ManufacturingTopSection;
